import { DefaultPageHeader } from 'layouts';
import type { UserBase } from 'models';
import { useGetMemberEntityBreadcrumb } from '../hooks';

type P = {
  member: UserBase;
};

const MemberProgramsHeader = ({ member }: P) => {
  const breadcrumbRoutes = useGetMemberEntityBreadcrumb({ entityScope: 'programs', member });

  return <DefaultPageHeader routes={breadcrumbRoutes} title="Joined programs" />;
};

export default MemberProgramsHeader;
